import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subject, switchMap } from 'rxjs';
import { SwapWifiService } from 'src/app/services/swap-wifi.service';
import { ConfirmDialogService } from '../swap-wifi-shared-module/confirm-dialog/confirm-dialog.service';

@Component({
  selector: 'app-pull-up-swap-wifi',
  templateUrl: './pull-up-swap-wifi.component.html',
  styleUrls: ['./pull-up-swap-wifi.component.scss'],
})
export class PullUpSwapWifiComponent implements OnInit {
  typePopup: any;
  version: any;
  dateList: any = [
    {
      date: '20/11',
      day: 'Thứ 2',
    },
    {
      date: '21/11',
      day: 'Thứ 3',
    },
    {
      date: '22/11',
      day: 'Thứ 4',
    },
    {
      date: '23/11',
      day: 'Thứ 5',
    },
    {
      date: '24/11',
      day: 'Thứ 6',
    },
  ];
  selectItems: any = {
    date: '',
  };
  listTime: any = [
    {
      id: 1,
      time: 'Thứ 3, 21/11/2023 08:00 - 10:00',
    },
    {
      id: 2,
      time: 'Thứ 3, 21/11/2023 10:00 - 12:00',
    },
    {
      id: 3,
      time: 'Thứ 3, 21/11/2023 13:00 - 15:00',
    },
    {
      id: 4,
      time: 'Thứ 3, 21/11/2023 15:00 - 17:00',
    },
  ];
  selectedTime: any;
  selectedDate: any;
  apointmentTime: any;
  apointmentSubscription: any;
  dateApointment: any;
  firstTime: any;
  firstActiveTime: any;
  dataPopup: any;
  readonly getApointmentTimeSubject = new Subject();
  @Output() modalEvent = new EventEmitter<any>();
  constructor(
    public swapWifiService: SwapWifiService,
    readonly activeModal: NgbActiveModal,
    readonly spinner: NgxSpinnerService,
    readonly confirm: ConfirmDialogService
  ) {}

  ngOnInit(): void {
    console.log(this.dataPopup);
    if (this.typePopup === 'date-picker') {
      this.spinner.show();
      console.log(this.dataPopup.time_installation);
      if (this.dataPopup.time_installation.is_warning) {
        let date = this.swapWifiService.convertDateToDDMMYYYY(
          new Date(
            new Date().getFullYear(),
            new Date().getMonth(),
            new Date().getDate() + 4
          )
        );
        this.selectedDate = this.dateApointment =
          this.swapWifiService.convertDateToDDMMYYYY(date);
        this.getDateList(this.dateApointment);
      } else {
        this.selectedDate = this.dataPopup.time_installation.date;
        this.selectedTime = this.dataPopup.time_installation;
        this.getDateList(this.dataPopup.time_installation.date);
        console.log(this.selectedDate);
      }

      this.apointmentSubscription = this.getApointmentTimeSubject
        .pipe(
          switchMap((date) => this.swapWifiService.getAppointmentTime(this.version, date))
        )
        .subscribe(
          (res: any) => {
            this.spinner.hide();
            if (res && res.status === 1) {
              this.listTime = res.detail.list_time_slot;
              this.apointmentTime = this.firstActiveTime = this.listTime.find(
                (element: any) => element.is_available
              );
              this.firstTime = this.firstActiveTime
                ? this.firstActiveTime.time_slot
                : undefined;
            } else {
              this.confirm.confirm(
                'Thông báo',
                res.msg,
                'Đóng',
                undefined,
                'justify-content-end'
              );
            }
          },
          (errors: any) => {
            this.spinner.hide();
          }
        );
      this.getApointmentTimeSubject.next({
        appointment_date: this.dataPopup.date_appointment,
        utm_source: this.dataPopup.utm_source,
        contract_no: this.dataPopup.contract_no,
        phone_nb: this.dataPopup.phone_nb,
      });
    }
  }
  handleChangeTime(e: any) {
    console.log(this.firstTime);
    console.log(e);
    this.selectedTime = e;
    this.modalEvent.emit(this.selectedTime);
    this.activeModal.close();
  }
  handleChangeDate(item: any) {
    this.selectedDate = item.appointment_date;
    this.spinner.show();
    this.getApointmentTimeSubject.next({
      appointment_date: item.appointment_date,
      utm_source: this.dataPopup.utm_source,
      contract_no: this.dataPopup.contract_no,
      phone_nb: this.dataPopup.phone_nb,
    });
  }
  closePopup() {
    this.activeModal.close();
  }
  getDateList(date: any) {
    console.log(date);
    let date2 =
      date.split('/')[2] + '/' + date.split('/')[1] + '/' + date.split('/')[0];
    this.dateList = [];
    for (let i = 0; i < 30; i++) {
      const currentDate = new Date(date2);

      currentDate.setDate(currentDate.getDate() + i);
      const day =
        currentDate.getDay() === 0 ? 'CN' : 'Thứ ' + (currentDate.getDay() + 1);
      const a = {
        appointment_date:
          String(currentDate.getDate()).padStart(2, '0') +
          '/' +
          String(currentDate.getMonth() + 1).padStart(2, '0') +
          '/' +
          currentDate.getFullYear(),
        date:
          String(currentDate.getDate()).padStart(2, '0') +
          '/' +
          String(currentDate.getMonth() + 1).padStart(2, '0'),
        day: day,
      };
      this.dateList.push(a);
    }
  }
}
